import React, { useEffect } from 'react';
import './Sidebar.css';
import useMainStore from '../../store/mainState';
import { ReactComponent as ArrowRight } from '../../assets/icons/blueArrowRight.svg';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/arrowDown.svg';

import AcardionItem from './AcardionItem';
import { features, menuItems } from '../../utils/menuItemsConst';
import AcardionMenuItem from './AcardionMenuItem';
import { useNavigate } from 'react-router-dom';
import useBalanceSubscription from '../../hooks/useBalanceSubscription';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../ui/LanguageSwitcher';

const Sidebar = () => {
  const { isCollapsed, user, activeItem, setActiveItem, activeSubItem, setActiveSubItem, setIsCollapsed } = useMainStore();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useBalanceSubscription();

  useEffect(() => {
      const handleBalanceUpdate = (event: any) => {
      };
  
      window.addEventListener('balanceUpdated', handleBalanceUpdate);
  
      return () => {
        window.removeEventListener('balanceUpdated', handleBalanceUpdate);
      };
    }, []);

    const onSelectItem = (item: string) => {
      setActiveItem(item);
      // Items without sub-menu navigate directly — close sidebar on mobile
      const menuItem = menuItems.find(m => m.id === item);
      if (menuItem && !('context' in menuItem && menuItem.context)) {
        navigate(`/${item}`);
        if (window.innerWidth < 768) {
          setIsCollapsed(true);
        }
      }
    };

    const OnSetActiveSubItem = (item: string) => {
      setActiveSubItem(item);
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
      }
    };

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      {user && (
        <div className="sidebar-header bg-gradient-to-r from-[#0077FF30] via-[#69AFFF08] to-white/[0.03] backdrop-blur-sm border border-white/[0.06] rounded-[16px] m-[10px] flex items-center gap-[10px]">
          <div className="sidebar-logo">
            <img src={require("../../assets/images/avatar.png")} alt="" />
          </div>
          <div className="sidebar-info ">
            <p className="text-[12px] font-bold text-[#FFFFFF]">{t('common.balance')}</p>
            <p className="text-[12px] font-bold text-[#FFFFFF]">{user.Balance.amount + user.Balance.onHold}</p>
          </div>
          <button className="right-arrow" onClick={() => navigate("profile")}>
            <ArrowRight />
          </button>
        </div>
      )}
      <nav className="sidebar-nav">
        {/* World Cup 2026 promo button */}
        <button
          aria-label="World Cup 2026"
          onClick={() => {
            setActiveItem('sport');
            setActiveSubItem('');
            navigate('/sport');
            if (window.innerWidth < 768) setIsCollapsed(true);
          }}
          className={`wc-menu-btn group ${isCollapsed ? 'wc-menu-btn--collapsed' : ''}`}
        >
          {/* Gradient base */}
          <span className="wc-menu-base" />
          {/* Gold pulsing glow */}
          <span className="wc-menu-glow" />
          {/* Shimmer sweep */}
          <span className="wc-menu-shimmer" />
          {/* LIVE pulse dot (top-right) */}
          <span className="wc-menu-live">
            <span className="wc-menu-live-dot" />
            {!isCollapsed && <span className="wc-menu-live-text">LIVE</span>}
          </span>

          {/* Spinning soccer ball */}
          <span className="wc-menu-ball">⚽</span>

          {!isCollapsed && (
            <span className="wc-menu-text">
              <span className="wc-menu-flags">🇺🇸 🇨🇦 🇲🇽</span>
              <span className="wc-menu-title">WORLD CUP</span>
              <span className="wc-menu-year">2026</span>
            </span>
          )}

          {!isCollapsed && (
            <span className="wc-menu-arrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          )}
        </button>

        {menuItems.map((item) => (
          <AcardionItem key={item.id} item={item} activeItem={activeItem} setActiveItem={onSelectItem} isCollapsed={isCollapsed}
            activeSubItem={activeSubItem} setActiveSubItem={OnSetActiveSubItem} />
        ))}
        <div className="accordion-item mt-[70px]">
          {features.context.map((item, index) => (
            <div key={item.id} className="accordion-item">
              <button
                className={`accordion-header ${activeItem === item.id ? 'active' : ''}`}
                onClick={() => { setActiveItem(activeItem === item.id ? null : item.id); navigate(item.id); if (window.innerWidth < 768) setIsCollapsed(true); }}
              >
                <div className="sidebar-item-icon">{item.icon}</div>
                {!isCollapsed && (
                  <>
                    <p className="sidebar-item-label"> {(item as any).isVip ? <><span className="text-[#0077FF]">VIP</span> {t(item.labelKey).replace('VIP ', '')}</> : t(item.labelKey)}</p>
                  </>
                )}
              </button>
            </div>
          ))}
        </div>

      </nav>
      <div className={`sidebar-bottom ${isCollapsed ? 'sidebar-bottom--collapsed' : ''}`}>
        <div className="sidebar-lang">
          <LanguageSwitcher dropUp />
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;